<template>
  <div>
    <PageHeader :items="items" :optionalItems="optionalItems" />

    <!--==================================-->
    <!--==================================-->
    <div class="dextop-table-view">
      <!-- table -->
      <div class="table-responsive api-keys-table">
        <vue-good-table
          styleClass="vgt-table striped"
          :columns="columns"
          :fixed-header="false"
          :rows="rows"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
            trigger: 'enter',
          }"
          :pagination-options="{
            enabled: false,
            perPage: pageLength,
          }"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <span v-if="props.column.field === 'createdAt'">
              {{ $dateFormatter(props.row.createdAt, $i18n.locale) }}
            </span>
            <span
              class="d-flex align-items-center justify-content-center gap-2"
              v-else-if="props.column.field === 'action'"
            >
              <div
                class="cursor-pointer"
                @click="$router.push(`/packages/${props.row.id}/show`)"
                v-if="$can(`${$route.meta.permission}.list`)"
              >
                <feather-icon size="16" icon="EyeIcon" />
              </div>
              <div
                v-if="$can(`${$route.meta.permission}.edit`)"
                class="cursor-pointer"
                @click="$router.push(`/packages/${props.row.id}/edit`)"
              >
                <feather-icon size="16" icon="Edit2Icon" />
              </div>
              <div
                v-if="$can(`${$route.meta.permission}.delete`)"
                class="cursor-pointer"
                @click="destroy(props.row.id)"
              >
                <feather-icon size="16" icon="TrashIcon" />
              </div> </span
            ><span v-else-if="props.column.field === 'costs'">
              {{
                $formatter(props.row.costs, $i18n.locale, "EUR", false, 2, 2)
              }}</span
            >

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-form-group>
          <div class="d-flex align-items-center">
            <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
            <b-form-select
              v-model="pageLength"
              :options="['25', '50', '100']"
              class="ml-1"
              @input="(value) => onPerPageChange({ pageLength: value })"
            />
          </div>
        </b-form-group>
        <div>
          <b-pagination
            :value="1"
            :total-rows="totalRecords"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value) => onPageChange({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="reponsive-view-cards">
      <b-row>
        <b-col cols="12" lg="4" md="6" v-for="row in rows" :key="row.id">
          <div class="card">
            <div
              class="card-header d-flex align-items-center justify-content-between"
            >
              <h5>{{ $t("name") }}: {{ row.name }}</h5>
              <div class="d-flex gap-3">
                <div
                  class="cursor-pointer"
                  @click="$router.push(`/packages/${row.id}/show`)"
                  :title="$t('View Package')"
                >
                  <feather-icon size="18" icon="EyeIcon" />
                </div>

                <div
                  v-if="$can(`${$route.meta.permission}.edit`)"
                  class="cursor-pointer"
                  @click="$router.push(`/packages/${row.id}/edit`)"
                  :title="$t('Edit Package')"
                >
                  <feather-icon size="18" icon="Edit2Icon" />
                </div>

                <!-- Delete Button -->
                <div
                  v-if="$can(`${$route.meta.permission}.delete`)"
                  class="cursor-pointer"
                  @click="destroy(row.id)"
                  :title="$t('deletePackage')"
                >
                  <feather-icon size="18" icon="TrashIcon" />
                </div>
              </div>
            </div>

            <div class="card-body pt-0">
              <ul class="card-list">
                <li>
                  <div class="left">
                    <strong>{{ $t("dentalTwinCredits") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.credits }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("costs") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{
                      $formatter(row.costs, $i18n.locale, "EUR", false, 2, 2)
                    }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("creationDate") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{
                      $dateFormatter(row.createdAt, $i18n.locale)
                    }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="d-flex justify-content-center mt-2">
            <b-pagination
              :value="1"
              :total-rows="totalRecords"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => onPageChange({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <!--==================================-->
    <!--==================================-->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    PageHeader,
    Multiselect,
  },
  computed: {
    optionalItems() {
      return {
        createBtn1: {
          show: true,
          text: this.$t("createPackage"),
          icon: "PlusIcon",
          path: "/packages/create",
          permission: `${this.$route.meta.permission}.create`,
        },
      };
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("packages"),
          active: true,
        },
      ];
    },
    columns() {
      return [
        {
          label: this.$t("name"),
          field: "name",
        },
        {
          label: this.$t("dentalTwinCredits"),
          field: "credits",
        },
        {
          label: this.$t("costs"),
          field: "costs",
        },
        {
          label: this.$t("creationDate"),
          field: "createdAt",
        },
        {
          tdClass: "vgt-center-align",
          thClass: "vgt-center-align",
          label: this.$t("action"),
          field: "action",
          sortable: false,
        },
      ];
    },
  },
  data() {
    return {
      totalRecords: 0,
      pageLength: 25,
      page: 1,
      form: {
        sortBy: "createdAt",
        sortOrder: "desc",
      },
      rows: [],
      searchTerm: "",
    };
  },

  async created() {
    this.loadItems();
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },

    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },

    onSortChange(params) {
      this.form.sortOrder = params[0].type;
      if (params[0].type == "none") this.form.sortOrder = "asc";
      this.form.sortBy = params[0].field;
      this.loadItems();
    },

    // load items is what brings back the rows from server
    async loadItems() {
      try {
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch("packages/list", {
          page: this.page,
          ...this.form,
          perPage: this.pageLength,
        });
        this.rows = response?.data?.data;
        this.totalRecords = response?.data?.total;
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async destroy(id) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        await this.$store.dispatch("packages/destroy", id).finally(() => {
          this.loadItems();
        });
      }
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
